/**
 * Service para Checkout View - comunica com a API
 */

import { getApiBaseUrl } from '../../../utils/apiConfig';

export async function fetchCheckoutContador(token) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/contador`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return 0;
  const json = await res.json();
  return json.success && json.data && typeof json.data.qtde === 'number' ? json.data.qtde : 0;
}

export async function fetchCheckoutResumo(token) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/resumo`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `Erro ${res.status}`);
  }

  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Erro ao buscar resumo');
  return json.data;
}

export async function fetchAdhocOsEnrichBySerial(token, serials) {
  const list = Array.isArray(serials)
    ? [...new Set(serials.map((s) => String(s ?? '').trim()).filter(Boolean))]
    : [];
  if (!list.length) return {};
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/adhoc-os-enrich`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ serials: list }),
  });
  if (!res.ok) return {};
  const json = await res.json().catch(() => ({}));
  return json.success && json.data && typeof json.data === 'object' ? json.data : {};
}

export async function fetchAdhocOsContext(token, operationCode) {
  const op = String(operationCode ?? '').trim();
  if (!op) throw new Error('operationCode é obrigatório');
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/adhoc-os/${encodeURIComponent(op)}/context`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao buscar atendimento avulso');
  }
  return json.data;
}

export async function fetchAdhocOsLocation(token, operationCode) {
  const op = String(operationCode ?? '').trim();
  if (!op) throw new Error('operationCode é obrigatório');
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/adhoc-os/${encodeURIComponent(op)}/location`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao obter localização do atendimento');
  }
  return json.data;
}

export async function createAdhocRegisteredOs(token, body) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/adhoc-os/create`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao abrir OS avulsa');
  }
  return json.data;
}

export async function fetchDisponibilidadeEstoque(token, codProd) {
  if (!codProd) return [];
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/disponibilidade-estoque?codProd=${encodeURIComponent(codProd)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  const json = await res.json();
  return json.success && Array.isArray(json.data) ? json.data : [];
}

export async function fetchCompatibilidade(token, codProd, codEmp) {
  if (!codProd) return [];
  const base = getApiBaseUrl();
  const params = new URLSearchParams({ codProd });
  if (codEmp != null && codEmp !== '') params.set('codEmp', String(codEmp));
  const res = await fetch(`${base}/api/checkout-view/compatibilidade?${params}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  const json = await res.json();
  return json.success && Array.isArray(json.data) ? json.data : [];
}

export async function fetchPecasCompativelModelo(token, codProdMaquina, codFechamento) {
  if (!codProdMaquina || !codFechamento) return [];
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/pecas-compativel-modelo?codProdMaquina=${encodeURIComponent(codProdMaquina)}&codFechamento=${encodeURIComponent(codFechamento)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  const json = await res.json();
  return json.success && Array.isArray(json.data) ? json.data : [];
}

export async function fetchPecasPendentes(token, codigoOs) {
  if (!codigoOs) return [];
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/pecas-pendentes?codigo=${encodeURIComponent(codigoOs)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  const json = await res.json();
  return json.success && Array.isArray(json.data) ? json.data : [];
}

export async function deletePecaPendente(token, codFechamento, codProd) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/peca-pendente/excluir`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ codFechamento, codProd })
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) throw new Error(json.message || 'Erro ao excluir peça');
  return json;
}

export async function incluirPecasPendentes(token, codFechamento, itens) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/pecas-pendentes/incluir`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ codFechamento, itens })
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) throw new Error(json.message || 'Erro ao incluir peças');
  return json;
}

export async function trocarPecaPendente(token, codFechamento, codProdRemover, codProdIncluir, qtde) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/peca-pendente/trocar`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ codFechamento, codProdRemover, codProdIncluir, qtde })
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) throw new Error(json.message || 'Erro ao trocar peça');
  return json;
}

export async function fetchPecasTrocadas(token, codigoOs) {
  if (!codigoOs) return [];
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/pecas-trocadas?codigo=${encodeURIComponent(codigoOs)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  const json = await res.json();
  return json.success && Array.isArray(json.data) ? json.data : [];
}

export async function fetchCondicoesSearch(token, q, codFechamento) {
  if (!q || String(q).trim().length < 4) return [];
  const base = getApiBaseUrl();
  const fech = codFechamento != null ? `&codFechamento=${encodeURIComponent(codFechamento)}` : '';
  const res = await fetch(`${base}/api/checkout-view/condicoes?q=${encodeURIComponent(q)}${fech}`, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
  });
  if (!res.ok) return [];
  const json = await res.json();
  return json.success && Array.isArray(json.data) ? json.data : [];
}

export async function updateCondicao(token, codFechamento, codCondition) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/condicao`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ codFechamento, codCondition })
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) throw new Error(json.message || 'Erro ao atualizar condição');
  return json.data;
}

export async function fetchFotos(token, numeroOS) {
  if (!numeroOS) return [];
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/fotos?numeroOS=${encodeURIComponent(numeroOS)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  const json = await res.json();
  return json.success && Array.isArray(json.data) ? json.data : [];
}

export async function fetchAssinatura(token, numeroOS) {
  if (!numeroOS) return null;
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/assinatura?numeroOS=${encodeURIComponent(numeroOS)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return null;
  const json = await res.json();
  if (!json.success || !json.data?.signatureSvg) return null;
  return json.data;
}

/** Rastreio GPS da OS (deslocamento + atendimento). hasTrack=false quando não há dados / plano sem Premium. */
export async function fetchOsRastreio(token, numeroOS) {
  if (!numeroOS) {
    return { hasTrack: false, points: [], trips: [], services: [] };
  }
  const base = getApiBaseUrl();
  const res = await fetch(
    `${base}/api/checkout-view/os-rastreio?numeroOS=${encodeURIComponent(numeroOS)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  if (!res.ok) return { hasTrack: false, points: [], trips: [], services: [] };
  const json = await res.json().catch(() => ({}));
  if (!json.success || !json.data) return { hasTrack: false, points: [], trips: [], services: [] };
  return json.data;
}

/**
 * Gera pedido via API (SP_LCMY_GPED) + reserva opcional (SP02019).
 * list: 'disponiveis' | 'indisponiveis'
 * produtos: [{ codigo }, ...]
 * Retorna { success, pedidoGerado, reserva } ou { success: false, error, reserva? }
 * reserva: { attempted, ok, skipped, tentativas, erros[] }
 */
export async function fetchGerarPedido(token, { numeroOS, codFechamento, list, produtos }) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/gerar-pedido`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ numeroOS, codFechamento, list, produtos })
  });
  const json = await res.json().catch(() => ({}));
  const reserva = json.data?.reserva || null;
  if (res.ok && json.success) {
    return {
      success: true,
      pedidoGerado: json.data?.pedidoGerado ?? null,
      reserva
    };
  }
  return {
    success: false,
    error: json.data?.error || { message: json.message || 'Erro ao gerar pedido' },
    reserva
  };
}

/**
 * Reexecuta só a reserva de estoque (SP02019) para pedido já gerado.
 * Retorna { success, reserva: { attempted, ok, skipped, tentativas, erros[] } }
 */
export async function fetchReservarPedido(token, { codFechamento, pedidoCodigo }) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/reservar-pedido`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ codFechamento, pedidoCodigo })
  });
  const json = await res.json().catch(() => ({}));
  const reserva = json.data?.reserva || {
    attempted: true,
    ok: false,
    skipped: false,
    tentativas: 0,
    erros: [{ message: json.message || 'Erro ao reservar estoque' }]
  };
  if (res.ok && json.success) {
    return { success: true, reserva };
  }
  return { success: false, reserva };
}

export async function fetchPedidoFechamentoDados(token, numeroOS, codPedido) {
  const base = getApiBaseUrl();
  const params = new URLSearchParams({
    numeroOS: String(numeroOS).trim(),
    codPedido: String(codPedido).trim()
  });
  const res = await fetch(`${base}/api/checkout-view/pedido-fechar-dados?${params}`, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) throw new Error(json.message || 'Erro ao carregar dados do pedido');
  return json.data;
}

export async function fetchTransportadorasPedido(token, q) {
  if (!q || String(q).trim().length < 4) return [];
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/transportadoras-pedido?q=${encodeURIComponent(String(q).trim())}`, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) return [];
  return Array.isArray(json.data) ? json.data : [];
}

export async function fetchClassificacoesPedido(token, q) {
  if (!q || String(q).trim().length < 4) return [];
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/classificacoes-pedido?q=${encodeURIComponent(String(q).trim())}`, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) return [];
  return Array.isArray(json.data) ? json.data : [];
}

export async function updatePedidoFechamentoApi(token, body) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/checkout-view/pedido-fechar`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) throw new Error(json.message || 'Erro ao atualizar pedido');
  return json;
}
